import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ReportingFilteringService } from '../../../pages/reports-page/services/reporting-filtering.service';
import { ResiService } from '../../../api/resi.service';
import * as moment from 'moment';

@UntilDestroy()
@Component({
  selector: 'iv-date-range',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss']
})

// Implemented Angular Material DateRangePicker (V10.1.2) similar to EMEA v10 upgrade.

export class InvoiceDateRangePickerComponent implements OnInit {
  @Input() startDate;
  @Input() endDate;
  @Input() disableToggleButton = false;
  @Input() disableDatePicker = true;
  @Input() sourcePage;
  @Input() label = "";
  @Input() matLabel = "";
  @Output() emitSelectedDates: EventEmitter<any>;

  dateRangePickerForm: UntypedFormGroup;
  displayClearButton = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private resiService: ResiService,
    private filterService: ReportingFilteringService) {
    this.emitSelectedDates = new EventEmitter();
  }

  ngOnInit() {
    if (this.startDate && this.endDate) {
      this.displayClearButton = true;
      this.dateRangePickerForm = this.formBuilder.group({
        startDate: moment(this.startDate),
        endDate: moment(this.endDate)
      });
    } else {
      this.dateRangePickerForm = this.formBuilder.group({
        startDate: undefined,
        endDate: undefined
      });
    }

    this.resiService.clearDateRange.asObservable()
      .pipe(untilDestroyed(this))
      .subscribe(resetDate => {
      if (resetDate) {
        this.clearDateRange();
      }
    });
    this.filterService.clearDateRange.asObservable()
      .pipe(untilDestroyed(this))
      .subscribe(resetDate => {
      if (resetDate) {
        this.clearDateRange();
      }
    });
  }

  onSelectionChanged(callFrom) {
    const startDate = this.dateRangePickerForm.get('startDate')?.value;
    let endDate = this.dateRangePickerForm.get('endDate')?.value;
    if (callFrom === 'start' && endDate) {
      this.dateRangePickerForm.get('endDate')?.patchValue(undefined);
      endDate = undefined;
    }

    if (startDate && endDate) {
      this.displayClearButton = true;
      this.emitSelectedDates.emit(this.dateRangePickerForm.value);
    }
  }

  clearDateRange() {
    this.dateRangePickerForm.patchValue({ startDate: undefined, endDate: undefined }, { emitEvent: false });
    this.displayClearButton = false;
    this.emitSelectedDates.emit(this.dateRangePickerForm.value);
  }

  onDatePickerClosed() {
    const startDate = this.dateRangePickerForm.get('startDate')?.value;
    const endDate = this.dateRangePickerForm.get('endDate')?.value;
    if (startDate && !endDate) {
      const lastStartDate = this.startDate ? moment(this.startDate) : undefined;
      const lastEndDate = this.endDate ? moment(this.endDate) : undefined;
      this.dateRangePickerForm.patchValue({ startDate: lastStartDate, endDate: lastEndDate }, { emitEvent: false });
      this.emitSelectedDates.emit(this.dateRangePickerForm.value);
    }
  }
}
